const languageZh ={"10000":"Tayangan Panas"}; export default languageZh


// WEBPACK FOOTER //
// ./src/language/ms.js